const { useAuth } = require("../context/AuthContext");
const { recuperarCache } = require("../services/cacheHandler");
/**
 * Enum com todas as permissões disponíveis no sistema
 */
const PERMISSOES = {
    // Permissões para USUÁRIO
    USUARIO_LISTAR: "ROLE_USUARIO_LISTAR",
    USUARIO_CADASTRAR: "ROLE_USUARIO_CADASTRAR",
    USUARIO_EDITAR: "ROLE_USUARIO_EDITAR",
    USUARIO_REMOVER: "ROLE_USUARIO_REMOVER",
    
    // Permissões para CLIENTE
    CLIENTE_LISTAR: "ROLE_CLIENTE_LISTAR",
    CLIENTE_CADASTRAR: "ROLE_CLIENTE_CADASTRAR",
    CLIENTE_EDITAR: "ROLE_CLIENTE_EDITAR",
    CLIENTE_REMOVER: "ROLE_CLIENTE_REMOVER",
    
    // Permissões para SISTEMA
    SISTEMA_LISTAR: "ROLE_SISTEMA_LISTAR",
    SISTEMA_CADASTRAR: "ROLE_SISTEMA_CADASTRAR",
    SISTEMA_EDITAR: "ROLE_SISTEMA_EDITAR",
    SISTEMA_REMOVER: "ROLE_SISTEMA_REMOVER",
    
    // Permissões para EMPRESA
    EMPRESA_LISTAR: "ROLE_EMPRESA_LISTAR",
    EMPRESA_CADASTRAR: "ROLE_EMPRESA_CADASTRAR",
    EMPRESA_EDITAR: "ROLE_EMPRESA_EDITAR",
    EMPRESA_REMOVER: "ROLE_EMPRESA_REMOVER",

    // Permissões para EQUIPAMENTO
    EQUIPAMENTO_LISTAR: "ROLE_EQUIPAMENTO_LISTAR",
    EQUIPAMENTO_REMOVER: "ROLE_EQUIPAMENTO_REMOVER",

    // Permissões para AUDITORIA
    AUDITORIA_LISTAR: "ROLE_AUDITORIA_LISTAR",

    // Permissões para CHAVE API
    APIKEY_LISTAR: "ROLE_APIKEY_LISTAR", 
    APIKEY_EDITAR: "ROLE_APIKEY_EDITAR", 
    APIKEY_CADASTRAR: "ROLE_APIKEY_CADASTRAR", 
};

/**
 * Verifica se o usuário possui a permissão necessária
 * @param {string} permissaoNecessaria - Código da permissão necessária (ex: ROLE_USUARIO_LISTAR)
 * @returns {boolean} - Verdadeiro se o usuário possui a permissão
 */
const validarPermissoes = (permissaoNecessaria) => {
    // Corrigindo o nome da chave para 'permissoes'
    const permissoes = recuperarCache('permissoes');
    if (!permissoes) return false;
    
    return !!permissoes[permissaoNecessaria];
};

/**
 * Verifica se o usuário possui todas as permissões necessárias
 * @param {string[]} permissoesNecessarias - Lista de permissões necessárias
 * @returns {boolean} - Verdadeiro se o usuário possui todas as permissões
 */
const validarTodasPermissoes = (permissoesNecessarias) => {
    if (!Array.isArray(permissoesNecessarias) || permissoesNecessarias.length === 0) {
        return true;
    }
    
    return permissoesNecessarias.every(permissao => validarPermissoes(permissao));
};

/**
 * Verifica se o usuário possui pelo menos uma das permissões necessárias
 * @param {string[]} permissoesNecessarias - Lista de permissões necessárias
 * @returns {boolean} - Verdadeiro se o usuário possui pelo menos uma permissão
 */
const validarQualquerPermissao = (permissoesNecessarias) => {
    if (!Array.isArray(permissoesNecessarias) || permissoesNecessarias.length === 0) {
        return true;
    }
    
    return permissoesNecessarias.some(permissao => validarPermissoes(permissao));
};

/**
 * Verifica se o usuário é super admin (grupoPermissao === 'Administrador')
 * @returns {boolean} - Verdadeiro se for administrador
 */
const isSuperAdmin = () => {
    const usuario = recuperarCache('usuario');
    return usuario && (
        usuario.usuarioTO.grupoPermissao === GruposUsuario.ADMINISTRADOR ||
        usuario.usuarioTO.grupoPermissao === GruposUsuario.DESENVOLVEDOR
    );
};

const isDev = () => {
    const usuario = recuperarCache('usuario');
    return usuario && usuario.usuarioTO.grupoPermissao === GruposUsuario.DESENVOLVEDOR;
};

const GruposUsuario = {
    DESENVOLVEDOR: 'Desenvolvedor',
    ADMINISTRADOR: 'Administrador',
    GESTOR: 'Gestor',
    COMUM: 'Usuário Comum',
    VISUALIZADOR: 'Visualizador'
};

/**
 * Retorna true se o usuário atual for super admin (grupoPermissao === 'Administrador')
 */
const super_admin = isSuperAdmin();

module.exports = {
    PERMISSOES,
    validarPermissoes,
    validarTodasPermissoes,
    validarQualquerPermissao,
    isSuperAdmin,
    isDev,
    super_admin
};